/**
 * List and detail. Phones show one or the other; from 1024 px the detail opens beside the list so the queue
 * position is never lost (docs/52 §4.4, what Denise needs).
 */
import type { ComponentChildren, JSX } from 'preact';
import { S } from '@ff/app-ui/copy';

export function Split(p: { list: ComponentChildren; detail: ComponentChildren | null; empty?: ComponentChildren }): JSX.Element {
  return (
    <div class="split" data-has-detail={p.detail ? '' : undefined}>
      <div class="split-list">{p.list}</div>
      <div class="split-detail">{p.detail ?? <div class="split-placeholder">{p.empty ?? <p class="t-muted">{S.app.pickOne}</p>}</div>}</div>
    </div>
  );
}
